import { render, staticRenderFns } from "./OP_ChecklistSummary.vue?vue&type=template&id=2b3f234e&scoped=true&"
import script from "./OP_ChecklistSummary.vue?vue&type=script&lang=js&"
export * from "./OP_ChecklistSummary.vue?vue&type=script&lang=js&"
import style0 from "./OP_ChecklistSummary.vue?vue&type=style&index=0&id=2b3f234e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f234e",
  null
  
)

export default component.exports